import { mapEnumToOptions } from '@abp/ng.core';

export enum UserType {
  Fan = 1,
  Creator = 2,
}

export const userTypeOptions = mapEnumToOptions(UserType);
